import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const LinearProgressBar = ({
  value,
  className,
}) => {
  const textPositionClass = (value > 75) ? 'in' : 'out';

  return (
    <div className={classnames('ProgressBar', className, 'progress')}>
      <div className="progress-bar progress-bar-success" style={{ width: `${value}%` }}>
        <div className={`progress-bar-value ${textPositionClass}`}>
          {`${value}%`}
        </div>
      </div>
    </div>
  );
};

LinearProgressBar.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
};

LinearProgressBar.defaultProps = {
  value: 0,
  className: '',
};

export default LinearProgressBar;
